import axios, { RawAxiosRequestHeaders } from 'axios';
import { CodeResponse } from '../../../interfaces/interfaceServices';
import { redirectTo } from '../navigationService';

const deleteToken = () => {
  localStorage.removeItem('accessToken');
  redirectTo('/');
};

export const validateCode = async (
  phoneNumber: string,
  otp: string,
  isResending: boolean = false
): Promise<CodeResponse | undefined> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/identity-validation-bff/v1.0.0/otp`;
  const token = localStorage.getItem('accessToken');

  if (!token) {
    console.error('Token no encontrado. Por favor, inicia sesión nuevamente.');
    redirectTo('/');
    throw new Error('No se encontró el token de acceso');
  }

  let headersBase2: RawAxiosRequestHeaders = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-business': 'GASCO',
    'x-commerce': 'GASCO',
    'x-country': 'CL',
    'x-system': 'IdentityValidation',
    'x-user': 'GASCO_USER',
  };

  let headersBase1: RawAxiosRequestHeaders = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-business': 'GASCO',
    'x-commerce': 'GASCO',
    'x-country': 'CL',
    'x-system': 'IdentityValidation',
    'x-user': 'GASCO_USER',
    'x-provider': 'AWSSNS',  
  };

  let headersBase = isResending ? headersBase1 : headersBase2;


  try {
    const response = await axios.put(
      apiUrl,
      { phoneNumber: String(phoneNumber), otp: String(otp) },
      {
        headers: headersBase,
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Error al validar el código de verificación:',
        error.response ? error.response.data : error.message
      );

      const errorMessage = (error.response?.data || '')
        .toString()
        .trim()
        .toLowerCase();
      if (errorMessage === 'invalid token') {
        deleteToken();
      }
    } else {
      console.error('Error inesperado:', error);
    }
    throw error;
  }
};
